import React from 'react';
import { FormattedMessage } from 'react-intl';

import { WizardWrapper } from './styles';
import WizardPreview from './WizardPreview';
import WizardSidebar from './WizardSidebar';

import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const CableFlagWizard = props => {
  const {
    isSmartphone,
    userSizeUnit,
    isDesktop,
    targetDevice,
    cableDiameter,
    flagLength,
    onCableDiameterChangeClb,
    onFlagLengthChangeClb,
    slaveAngle,
    setSlaveAngle,
    isLastWizardPage,
    withMiddleLine = false,
    setWithMiddleLine,
    lineType,
    setLineType,
    lineThickness,
    onLineThicknessChangeClb,
    isDimesionTypeDiameter,
    setIsDimesionTypeDiameter,
    isFlagLengthAuto = false,
    setIsFlagLengthAuto,
    textOrientation = 'horizontal',
    setTextOrientation,
    crossSectionAreas,
    crossSelectedSection,
    setCrossSelectedSection,
    setCableDiameterByArea,
    isCableFlagSync,
    setIsCableFlagSync,
    setFlagMidLength
  } = props;

  const [expand, setExpand] = React.useState(true);
  const toggleAcordion = () => {
    setExpand((prev) => !prev);
  };

  return (
    <WizardWrapper $isLastWizardPage={isLastWizardPage} $isSmartphone={isSmartphone}>
      {isSmartphone && !isLastWizardPage && (
        <Accordion style={{ width: '100vw', margin: 0 }} expanded={expand} >
          <AccordionSummary expandIcon={<div onClick={toggleAcordion}><ExpandMoreIcon /></div>}>
            <Typography>
              <FormattedMessage id="app.editor.sideMenu.button.preview" defaultMessage="Preview" />
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <WizardPreview
              isDesktop={isDesktop}
              targetDevice={targetDevice}
              cableDiameter={cableDiameter}
              withSizes={!isLastWizardPage}
              flagLength={flagLength}
              slaveAngle={slaveAngle}
              isCableFlagSync={isCableFlagSync}
              withMiddleLine={withMiddleLine}
              lineType={lineType}
              lineThickness={lineThickness}
              isDimesionTypeDiameter={isDimesionTypeDiameter}
              isFlagLengthAuto={isFlagLengthAuto}
              textOrientation={textOrientation}
              crossSelectedSection={crossSelectedSection}
            />
          </AccordionDetails>
        </Accordion>
      )}
      {(!isSmartphone || (isSmartphone && isLastWizardPage)) && (
        <WizardPreview
          isDesktop={isDesktop}
          targetDevice={targetDevice}
          cableDiameter={cableDiameter}
          withSizes={true}
          flagLength={flagLength}
          slaveAngle={slaveAngle}
          isCableFlagSync={isCableFlagSync}
          withMiddleLine={withMiddleLine}
          lineType={lineType}
          lineThickness={lineThickness}
          isDimesionTypeDiameter={isDimesionTypeDiameter}
          isFlagLengthAuto={isFlagLengthAuto}
          textOrientation={textOrientation}
          crossSelectedSection={crossSelectedSection}
        />
      )}

      {!isLastWizardPage && (
        <WizardSidebar
          userSizeUnit={userSizeUnit}
          isDesktop={isDesktop}
          isSmartphone={isSmartphone}
          targetDevice={targetDevice}
          cableDiameter={cableDiameter}
          flagLength={flagLength}
          slaveAngle={slaveAngle}
          setSlaveAngle={setSlaveAngle}
          isCableFlagSync={isCableFlagSync}
          withMiddleLine={withMiddleLine}
          setWithMiddleLine={setWithMiddleLine}
          lineType={lineType}
          setLineType={setLineType}
          lineThickness={lineThickness}
          onLineThicknessChangeClb={onLineThicknessChangeClb}
          isDimesionTypeDiameter={isDimesionTypeDiameter}
          setIsDimesionTypeDiameter={setIsDimesionTypeDiameter}
          isFlagLengthAuto={isFlagLengthAuto}
          setIsFlagLengthAuto={setIsFlagLengthAuto}
          textOrientation={textOrientation}
          setTextOrientation={setTextOrientation}
          onCableDiameterChangeClb={onCableDiameterChangeClb}
          onFlagLengthChangeClb={onFlagLengthChangeClb}
          crossSectionAreas={crossSectionAreas}
          crossSelectedSection={crossSelectedSection}
          setCrossSelectedSection={setCrossSelectedSection}
          setCableDiameterByArea={setCableDiameterByArea}
          setFlagMidLength={setFlagMidLength}
          setIsCableFlagSync={setIsCableFlagSync}
        />
      )}
    </WizardWrapper>
  );
};

export default React.memo(CableFlagWizard);
